import { Component, inject, Input, OnInit } from '@angular/core';
import { MessageMaintenance } from '../../models/message-maintenance';
import { TuiAlertService, TuiButton, TuiError, TuiLabel, TuiNotification, TuiTextfield } from '@taiga-ui/core';
import { TuiInputModule, TuiTextfieldControllerModule } from '@taiga-ui/legacy';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TuiFieldErrorPipe } from '@taiga-ui/kit';
import { AsyncPipe } from '@angular/common';
import { MessageMaintenanceService } from '../../services/message-maintenance.service';


@Component({
  selector: 'app-message-maintenance-form',
  standalone: true,
  imports: [
    TuiInputModule,
    TuiButton,
    TuiLabel,
    TuiTextfield,
    ReactiveFormsModule,
    TuiError,
    TuiFieldErrorPipe,
    AsyncPipe,
    TuiTextfieldControllerModule,
  ],
  templateUrl: './message-maintenance-form.component.html',
  styleUrl: './message-maintenance-form.component.scss'
})
export class MessageMaintenanceFormComponent implements OnInit {
  @Input()
  public messageMaintenance?: MessageMaintenance;
  @Input({ required: true })
  public onClose!: () => void;
  @Input({ required: true })
  public refreshList!: () => void;
  form!: FormGroup;

  private readonly messageMaintenanceService: MessageMaintenanceService = inject(MessageMaintenanceService);
  private readonly alertService: TuiAlertService = inject(TuiAlertService);

  ngOnInit(): void {
    this.form = new FormGroup({
      message: new FormControl(this.messageMaintenance?.message ?? '', [Validators.required]),
    });
  }

  onSubmit(form: FormGroup) {
    if (form.valid) {
      let messageMaintenance: MessageMaintenance | Omit<MessageMaintenance, "id"> = this.messageMaintenance ?? { message: "" };
      messageMaintenance.message = form.value.message;
      this.messageMaintenanceService.push(messageMaintenance).subscribe({
        next: () => {
          this.alertService
            .open('Message de maintenance publié avec succès', { label: 'Succès', appearance: 'success', autoClose: 10000 })
            .subscribe();
          this.refreshList();
        },
        error: () => {
          this.alertService
            .open('Une erreur est survenue lors de la publication du message de maintenance. Veuillez réessayer.', { label: 'Erreur', appearance: 'error', autoClose: 10000 })
            .subscribe();
          this.refreshList();
        }
      });
      this.onClose();
    }
  }
}
